module.exports = __webpack_public_path__ + "img/attack_god_sword.51938ae8.png";